import { containsUrl, isValidTelUrl } from 'wix-rich-content-common';

const isValidUrl = (url) => !!url && (containsUrl(url) || isValidTelUrl(url));

export { isValidUrl };
//# sourceMappingURL=utils.js.map
